import { FC, ReactNode } from "react";
import { CabinetCard } from "@/shared/ui/CabinetCard";
import { Navigation } from "@/widgets/Layout/Cabinet/ui/Navigation";
import { ProfileCard } from "@/widgets/ProfileCard";

interface Props {
  children: ReactNode;
}

const MobileLayout: FC<Props> = ({ children }) => {
  return (
    <>
      <section className="flex-col-gap-6 flex-1 overflow-y-auto px-0 py-4">
        <div className="px-4">
          <CabinetCard>
            <ProfileCard showDocuments />
          </CabinetCard>
        </div>
        {children}
      </section>
      <Navigation />
    </>
  );
};

export default MobileLayout;
